// import {Component, OnInit, ViewChild} from '@angular/core';
// import {AngularFirestore} from "@angular/fire/compat/firestore";
// import {CentreService} from "../../../../services/centre.service";
// import {Observable} from "rxjs";
// import {Centre} from "../../../../interfaces/Centres";
// import {FullChild} from "../../../../interfaces/FullChild";
// import {flowRight} from "lodash";
// import {MatTableDataSource} from "@angular/material/table";
// import {MatPaginator} from "@angular/material/paginator";
// import {MatSort} from "@angular/material/sort";
// import {MatSnackBar} from "@angular/material/snack-bar";
// import * as XLSX from "xlsx";
// import {MatSelectChange} from "@angular/material/select";
// import {Timestamp} from "firebase/firestore";
// import {PermissionType} from "../../../../components/employee/PermissionType.enum";
//
// @Component({
//   selector: 'app-unit-report',
//   templateUrl: './unit-report.component.html',
//   styleUrls: ['./unit-report.component.scss']
// })
// export class UnitReportComponent implements OnInit {
//   startDate: Date | null = null
//   endDate: Date | null = null
//   $mCentres$: Observable<Centre[]>
//
//   selectedCentre:any;
//   displayCentre = (c: any) => c?.centreName;
//   centreSelected: any[] = [];
//   mData: any[] = []
//   displayedColumns: string[] = ['name', "centre", 'childCode', 'dateOfAdmission', 'transferFrom','transferDate', 'dateOfDischarge', 'unit', 'floor','type'];
//   dataSource: MatTableDataSource<any>;
//   @ViewChild(MatPaginator) paginator!: MatPaginator;
//   @ViewChild(MatSort) sort!: MatSort;
//   fileName = 'Unit_Report.xlsx';
//   mFloorArray: string[] = ['Ground Floor'];
//   isLoading = false;  // New loading flag
//   constructor(private readonly mFirestore: AngularFirestore,
//               private readonly snackbar: MatSnackBar,
//               private readonly mCentre: CentreService) {
//     this.$mCentres$ = mCentre.getAllCentres()
//     this.dataSource = new MatTableDataSource();
//   }
//
//   ngOnInit(): void {
//     this.dataSource.paginator = this.paginator;
//     this.dataSource.sort = this.sort;
//   }
//
//   // onCentreSelect(selectedCentre: Centre) {
//   //   if (!selectedCentre) return;
//   //
//   //   console.log("Selected Centre:", selectedCentre);
//   //
//   //   this.selectedCentre = selectedCentre;
//   //
//   //   // // 1️⃣ Set centre details in form
//   //   // this.studentForm.patchValue({
//   //   //   centreName: selectedCentre.centreName,
//   //   //   centreCode: selectedCentre.centreCode
//   //   // });
//   // }
//
//
//   exportexcel() {
//     let element = document.getElementById('excel-table');
//     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
//     ws['!cols'] = [];
//     ws['!cols'][19] = {hidden: true};
//     const wb: XLSX.WorkBook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
//     XLSX.writeFile(wb, this.fileName);
//   }
//
//   Clear() {
//     this.startDate = null
//     this.endDate = null
//     this.selectedCentre = [];
//     this.mFloorArray = [];
//     this.dataSource = new MatTableDataSource();
//   }
//
//
//   applyFilter(event: Event) {
//     const filterValue = (event.target as HTMLInputElement).value;
//     this.dataSource.filter = filterValue.trim().toLowerCase();
//   }
//
//   search() {
//     this.isLoading = true;  // New loading flag
//     let mChildren: FullChild[] = [];
//     this.mData = [];
//     if (this.centreSelected.length === 0 &&  this.startDate == null && this.endDate == null) {
//       this.snackbar.open('Please select a date range and at least one centre', '', {
//         duration: 3000,
//         panelClass: 'error'
//       });
//       this.isLoading = false;
//       return;
//       // this.isLoading = false;
//     }
//
//     function getFloor(centreCode: string, currentUnit: string) {
//       switch (centreCode) {
//         case "ALAhmedabad": {
//           let floor = ''
//           if (currentUnit == "ALAhmedabad-1" || currentUnit == "ALAhmedabad-2" || currentUnit == "ALAhmedabad-3" || currentUnit == "ALAhmedabad-4" || currentUnit == "ALAhmedabad-5" || currentUnit == "ALAhmedabad-6") {
//             floor = "Ground Floor"
//           } else if (currentUnit == "ALAhmedabad-7" || currentUnit == "ALAhmedabad-8" || currentUnit == "ALAhmedabad-9" || currentUnit == "ALAhmedabad-10" || currentUnit == "ALAhmedabad-11" || currentUnit == "ALAhmedabad-12") {
//             floor = "1st Floor"
//           } else if (currentUnit == "ALAhmedabad-13" || currentUnit == "ALAhmedabad-14" || currentUnit == "ALAhmedabad-15") {
//             floor = "2nd Floor"
//           } else if (currentUnit == "ALAhmedabad-16" || currentUnit == "ALAhmedabad-17" || currentUnit == "ALAhmedabad-18" || currentUnit == "ALAhmedabad-19" || currentUnit == "ALAhmedabad-20") {
//             floor = "3rd Floor"
//           }
//           return floor
//         }
//         case "ALBangalore": {
//           let floor = ''
//           if (currentUnit == "ALBangalore-1" || currentUnit == "ALBangalore-2" || currentUnit == "ALBangalore-3" || currentUnit == "ALBangalore-4" || currentUnit == "ALBangalore-5" || currentUnit == "ALBangalore-6" || currentUnit == "ALBangalore-7" || currentUnit == "ALBangalore-8" || currentUnit == "ALBangalore-9") {
//             floor = "Ground Floor"
//           } else if (currentUnit == "ALBangalore-10" || currentUnit == "ALBangalore-11" || currentUnit == "ALBangalore-12" || currentUnit == "ALBangalore-13" || currentUnit == "ALBangalore-14" || currentUnit == "ALBangalore-15" || currentUnit == "ALBangalore-16" || currentUnit == "ALBangalore-17" || currentUnit == "ALBangalore-18" || currentUnit == "ALBangalore-19" || currentUnit == "ALBangalore-20" || currentUnit == "ALBangalore-21" || currentUnit == "ALBangalore-21") {
//             floor = "1st Floor"
//           } else floor = ""
//           return floor
//
//         }
//         case "ALDiamondGarden": {
//           return 'Ground Floor'
//
//         }
//         case "ALChandigarh": {
//           let floor = ''
//           floor = ""
//
//           if (currentUnit == "ALChandigarh-1" || currentUnit == "ALChandigarh-2" || currentUnit == "ALChandigarh-3") {
//
//             floor = "Ground Floor"
//
//           }
//
//           if (currentUnit == "ALChandigarh-4" || currentUnit == "ALChandigarh-5" || currentUnit == "ALChandigarh-6" || currentUnit == "ALChandigarh-7" || currentUnit == "ALChandigarh-8" || currentUnit == "ALChandigarh-9" || currentUnit == "ALChandigarh-10" || currentUnit == "ALChandigarh-11" || currentUnit == "ALChandigarh-12" || currentUnit == "ALChandigarh-13" || currentUnit == "ALChandigarh-14") {
//
//             floor = "1st Floor"
//
//           } else if (currentUnit == "ALChandigarh-15" || currentUnit == "ALChandigarh-16" || currentUnit == "ALChandigarh-17" || currentUnit == "ALChandigarh-18" || currentUnit == "ALChandigarh-19" || currentUnit == "ALChandigarh-20") {
//
//             floor = "2nd Floor"
//
//           } else floor = ""
//
//           return floor
//
//         }
//         case "ALGurunanak": {
//           let floor = ''
//           if (currentUnit == "ALGurunanak-1" || currentUnit == "ALGurunanak-2" || currentUnit == "ALGurunanak-3" || currentUnit == "ALGurunanak-4" || currentUnit == "ALGurunanak-5" || currentUnit == "ALGurunanak-6" || currentUnit == "ALGurunanak-7" || currentUnit == "ALGurunanak-8" || currentUnit == "ALGurunanak-9" || currentUnit == "ALGurunanak-10" || currentUnit == "ALGurunanak-11") {
//             floor = "Ground Floor"
//           }
//           else    if (currentUnit == "ALGurunanak-12" || currentUnit == "ALGurunanak-13" || currentUnit == "ALGurunanak-14" || currentUnit == "ALGurunanak-15" || currentUnit == "ALGurunanak-16" || currentUnit == "ALGurunanak-17" || currentUnit == "ALGurunanak-18" || currentUnit == "ALGurunanak-19" || currentUnit == "ALGurunanak-20" || currentUnit == "ALGurunanak-21" || currentUnit == "ALGurunanak-22" || currentUnit == "ALGurunanak-23" || currentUnit == "ALGurunanak-24" || currentUnit == "ALGurunanak-25" || currentUnit == "ALGurunanak-26") {
//
//             floor = "1st Floor"
//
//           } else if (currentUnit == "ALGurunanak-27" || currentUnit == "ALGurunanak-28" || currentUnit == "ALGurunanak-29" || currentUnit == "ALGurunanak-30") {
//
//             floor = "2nd Floor"
//
//           } else floor = ""
//           return floor
//
//         }
//         case "ALManipal": {
//
//           return "Ground Floor"
//         }
//         case "ALSanduGarden": {
//           let floor = ""
//           if (currentUnit == "ALSanduGarden-1" || currentUnit == "ALSanduGarden-2") {
//             floor = "Ground Floor"
//             return floor
//
//           }
//           else if (currentUnit == "ALSanduGarden-3" || currentUnit == "ALSanduGarden-4" || currentUnit == "ALSanduGarden-5" || currentUnit == "ALSanduGarden-6") {
//             floor = "1st Floor"
//             return floor;
//           }
//           else if (currentUnit == "ALSanduGarden-7" || currentUnit == "ALSanduGarden-8" || currentUnit == "ALSanduGarden-9" || currentUnit == "ALSanduGarden-10") {
//             floor = "2nd Floor"
//             return floor
//
//
//           } else if (currentUnit == "ALSanduGarden-11" || currentUnit == "ALSanduGarden-12" || currentUnit == "ALSanduGarden-13" || currentUnit == "ALSanduGarden-14") {
//             floor = "3rd Floor"
//             return floor
//
//           }
//           return floor
//         }
//         case "ALPune": {
//           return "Ground Floor"
//         }
//         default:
//           return 'Ground Floor'
//       }
//     }
//
//     if (this.startDate != null && this.endDate != null && this.centreSelected.length > 0) {
//       this.mFirestore.collection<FullChild>('ALChild').valueChanges().subscribe(res => {
//         mChildren = res;
//         mChildren.forEach(child => {
//           child.admissionData.forEach((ad, i) => {
//             if (i % 2 === 0) {
//               const isSelectedCentre = this.centreSelected.includes(ad.centreCode) || this.centreSelected.includes(ad.transferFrom);
//               if (ad.dateOfAdmission?.toDate()!! >= this.startDate!! && ad.dateOfAdmission?.toDate()!! <= this.endDate!! && isSelectedCentre) {
//                 let obj: any = {
//                   "name": child.firstName + ' ' + child.lastName,
//                   "centre": child.centreCode,
//                   "unit": ad.currentUnit,
//                   "childCode": child.childCode,
//                   "floor": getFloor(ad.centreCode, ad.currentUnit),
//                   "dateOfAdmission": ad.dateOfAdmission?.toDate(),
//                   "transferFromUnit": ad.transferFromUnit,
//                   "transferFrom": ad.transferFrom,
//                   "transferDate": (ad.transferDate as unknown as Timestamp)?.toDate(),
//                   "type": (child.admissionData.length > 2) ? 'Follow Up' : 'New'
//                 };
//                 if (child.admissionData[i + 1]) {
//                   obj = {
//                     ...obj,
//                     "dateOfDischarge": child.admissionData[i + 1].dateOfDischarge!!.toDate()
//                   };
//                 }
//                 this.mData.push(obj);
//               }
//               // Admitted before date but discharged during date
//               if (ad.dateOfAdmission?.toDate()!! <= this.startDate!! && child.admissionData[i + 1] != null && child.admissionData[i + 1].dateOfDischarge!!.toDate() >= this.startDate!! && child.admissionData[i + 1].dateOfDischarge!!.toDate() <= this.endDate!! && isSelectedCentre) {
//                 let obj: any = {
//                   "name": child.firstName + ' ' + child.lastName,
//                   "centre": child.centreCode,
//                   "unit": ad.currentUnit,
//                   "childCode": child.childCode,
//                   "floor": getFloor(ad.centreCode, ad.currentUnit),
//                   "dateOfAdmission": ad.dateOfAdmission?.toDate(),
//                   "transferFromUnit": ad.transferFromUnit,
//                   "transferFrom": ad.transferFrom,
//                   "transferDate": (ad.transferDate as unknown as Timestamp)?.toDate(),
//                   "type": (child.admissionData.length > 2) ? 'Follow Up' : 'New'
//                 };
//                 if (child.admissionData[i + 1]) {
//                   obj = {
//                     ...obj,
//                     "dateOfDischarge": child.admissionData[i + 1].dateOfDischarge!!.toDate()
//                   };
//                 }
//
//                 this.mData.push(obj);
//                 //  this.isLoading = false;
//               }
//               // Admitted before date but never discharged
//               if (ad.dateOfAdmission?.toDate()!! < this.startDate!! && child.admissionData[i + 1] == null && isSelectedCentre) {
//                 let obj: any = {
//                   "name": child.firstName + ' ' + child.lastName,
//                   "centre": child.centreCode,
//                   "unit": ad.currentUnit,
//                   "childCode": child.childCode,
//                   "floor": getFloor(ad.centreCode, ad.currentUnit),
//                   "dateOfAdmission": ad.dateOfAdmission?.toDate(),
//                   "transferFromUnit": ad.transferFromUnit,
//                   "transferFrom": ad.transferFrom,
//                   "transferDate": (ad.transferDate as unknown as Timestamp)?.toDate(),
//                   "type": (child.admissionData.length > 2) ? 'Follow Up' : 'New'
//                 };
//                 if (child.admissionData[i + 1]) {
//                   obj = {
//                     ...obj,
//                     "dateOfDischarge": child.admissionData[i + 1].dateOfDischarge!!.toDate()
//                   };
//                 }
//                 this.mData.push(obj);
//                 //  this.isLoading = false;
//               }
//             }
//           });
//         });
//
//         this.dataSource = new MatTableDataSource(this.mData);
//         this.dataSource.paginator = this.paginator;
//         this.dataSource.sort = this.sort;
//         this.isLoading = false;
//       });
//     }
//   }
//
//   // onCentreSelect($event: MatSelectChange) {
//   //   this.centreSelected = $event.value;
//   //   this.mFloorArray = [];
//   //
//   //   if (this.centreSelected.includes('ALAhmedabad')) {
//   //     this.mFloorArray.push('Ground Floor', '1st Floor', '2nd Floor');
//   //   }
//   //   if (this.centreSelected.includes('ALBangalore')) {
//   //     this.mFloorArray.push('Ground Floor', '1st Floor');
//   //   }
//   //   if (this.centreSelected.includes('ALChandigarh')) {
//   //     this.mFloorArray.push('Ground Floor', '1st Floor', '2nd Floor');
//   //   }
//   //   if (this.centreSelected.includes('ALDiamondGarden')) {
//   //     this.mFloorArray.push('Ground Floor');
//   //   }
//   //   if (this.centreSelected.includes('ALGurunanak')) {
//   //     this.mFloorArray.push('Ground Floor', '1st Floor', '2nd Floor');
//   //   }
//   //   if (this.centreSelected.includes('ALManipal')) {
//   //     this.mFloorArray.push('Ground Floor');
//   //   }
//   //   if (this.centreSelected.includes('ALPune')) {
//   //     this.mFloorArray.push('Ground Floor');
//   //   }
//   //   if (this.centreSelected.includes('ALSanduGarden')) {
//   //     this.mFloorArray.push('Ground Floor', '1st Floor', '2nd Floor', '3rd Floor');
//   //   }
//   //
//   //   // Remove duplicates
//   //   this.mFloorArray = Array.from(new Set(this.mFloorArray));
//   // }
//
//   onCentreSelect(selectedCentres: Centre[]) {
//     if (!selectedCentres || selectedCentres.length === 0) {
//       this.centreSelected = [];
//       this.mFloorArray = [];
//       return;
//     }
//
//     //  convert Centre[] → centreCode[]
//     this.centreSelected = selectedCentres.map(c => c.centreCode);
//
//     this.mFloorArray = [];
//
//     if (this.centreSelected.includes('ALAhmedabad')) {
//       this.mFloorArray.push('Ground Floor', '1st Floor', '2nd Floor');
//     }
//     if (this.centreSelected.includes('ALBangalore')) {
//       this.mFloorArray.push('Ground Floor', '1st Floor');
//     }
//     if (this.centreSelected.includes('ALChandigarh')) {
//       this.mFloorArray.push('Ground Floor', '1st Floor', '2nd Floor');
//     }
//     if (this.centreSelected.includes('ALDiamondGarden')) {
//       this.mFloorArray.push('Ground Floor');
//     }
//     if (this.centreSelected.includes('ALGurunanak')) {
//       this.mFloorArray.push('Ground Floor', '1st Floor', '2nd Floor');
//     }
//     if (this.centreSelected.includes('ALManipal')) {
//       this.mFloorArray.push('Ground Floor');
//     }
//     if (this.centreSelected.includes('ALPune')) {
//       this.mFloorArray.push('Ground Floor');
//     }
//     if (this.centreSelected.includes('ALSanduGarden')) {
//       this.mFloorArray.push('Ground Floor', '1st Floor', '2nd Floor', '3rd Floor');
//     }
//
//     // remove duplicates
//     this.mFloorArray = [...new Set(this.mFloorArray)];
//   }
//
//
//
//   onFloorSelect($event: MatSelectChange) {
//     let filterValue = $event.value;
//     if (filterValue == 'All') this.dataSource.filter = '';
//     if (filterValue != 'All') this.dataSource.filter = filterValue.trim().toLowerCase();
//   }
//
//   protected readonly PermissionType = PermissionType;
// }


import {Component, OnInit, ViewChild} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {CentreService} from "../../../../services/centre.service";
import {Observable, forkJoin, of} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatSnackBar} from "@angular/material/snack-bar";
import * as XLSX from "xlsx";
import {MatSelectChange} from "@angular/material/select";
import {Timestamp} from "firebase/firestore";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {map, take} from 'rxjs/operators';
import {FinancialYearService} from "../../../../services/financial-year.service";

@Component({
  selector: 'app-unit-report',
  templateUrl: './unit-report.component.html',
  styleUrls: ['./unit-report.component.scss']
})

export class UnitReportComponent implements OnInit {
  startDate: Date | null = null
  endDate: Date | null = null
  $mCentres$: Observable<Centre[]>

  selectedCentre: any;
  displayCentre = (c: any) => c?.centreName;
  centreSelected: any[] = [];
  mData: any[] = []
  displayedColumns: string[] = ['name', "centre", 'childCode', 'dateOfAdmission', 'transferFrom', 'transferDate', 'dateOfDischarge', 'unit', 'floor', 'type'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  fileName = 'Unit_Report.xlsx';
  mFloorArray: string[] = ['Ground Floor'];
  isLoading = false;

  constructor(private readonly mFirestore: AngularFirestore,
              private readonly snackbar: MatSnackBar,
              private readonly financialYearService: FinancialYearService,
              private readonly mCentre: CentreService) {
    this.$mCentres$ = mCentre.getAllCentres()
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  exportexcel() {
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    ws['!cols'] = [];
    ws['!cols'][19] = {hidden: true};
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }

  Clear() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.selectedCentre = [];
    this.mFloorArray = [];
    this.dataSource = new MatTableDataSource();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private getFloor(centreCode: string, currentUnit: string): string {
    switch (centreCode) {
      case "ALAhmedabad": {
        if (["ALAhmedabad-1", "ALAhmedabad-2", "ALAhmedabad-3", "ALAhmedabad-4", "ALAhmedabad-5", "ALAhmedabad-6"].includes(currentUnit)) {
          return "Ground Floor";
        } else if (["ALAhmedabad-7", "ALAhmedabad-8", "ALAhmedabad-9", "ALAhmedabad-10", "ALAhmedabad-11", "ALAhmedabad-12"].includes(currentUnit)) {
          return "1st Floor";
        } else if (["ALAhmedabad-13", "ALAhmedabad-14", "ALAhmedabad-15"].includes(currentUnit)) {
          return "2nd Floor";
        } else if (["ALAhmedabad-16", "ALAhmedabad-17", "ALAhmedabad-18", "ALAhmedabad-19", "ALAhmedabad-20"].includes(currentUnit)) {
          return "3rd Floor";
        }
        return "Ground Floor";
      }
      case "ALBangalore": {
        if (["ALBangalore-1", "ALBangalore-2", "ALBangalore-3", "ALBangalore-4", "ALBangalore-5", "ALBangalore-6", "ALBangalore-7", "ALBangalore-8", "ALBangalore-9"].includes(currentUnit)) {
          return "Ground Floor";
        } else if (["ALBangalore-10", "ALBangalore-11", "ALBangalore-12", "ALBangalore-13", "ALBangalore-14", "ALBangalore-15", "ALBangalore-16", "ALBangalore-17", "ALBangalore-18", "ALBangalore-19", "ALBangalore-20", "ALBangalore-21", "ALBangalore-22"].includes(currentUnit)) {
          return "1st Floor";
        }
        return "Ground Floor";
      }
      case "ALDiamondGarden":
        return 'Ground Floor';
      case "ALChandigarh": {
        if (["ALChandigarh-1", "ALChandigarh-2", "ALChandigarh-3"].includes(currentUnit)) {
          return "Ground Floor";
        } else if (["ALChandigarh-4", "ALChandigarh-5", "ALChandigarh-6", "ALChandigarh-7", "ALChandigarh-8", "ALChandigarh-9", "ALChandigarh-10", "ALChandigarh-11", "ALChandigarh-12", "ALChandigarh-13", "ALChandigarh-14"].includes(currentUnit)) {
          return "1st Floor";
        } else if (["ALChandigarh-15", "ALChandigarh-16", "ALChandigarh-17", "ALChandigarh-18", "ALChandigarh-19", "ALChandigarh-20"].includes(currentUnit)) {
          return "2nd Floor";
        }
        return "Ground Floor";
      }
      case "ALGurunanak": {
        if (["ALGurunanak-1", "ALGurunanak-2", "ALGurunanak-3", "ALGurunanak-4", "ALGurunanak-5", "ALGurunanak-6", "ALGurunanak-7", "ALGurunanak-8", "ALGurunanak-9", "ALGurunanak-10", "ALGurunanak-11"].includes(currentUnit)) {
          return "Ground Floor";
        } else if (["ALGurunanak-12", "ALGurunanak-13", "ALGurunanak-14", "ALGurunanak-15", "ALGurunanak-16", "ALGurunanak-17", "ALGurunanak-18", "ALGurunanak-19", "ALGurunanak-20", "ALGurunanak-21", "ALGurunanak-22", "ALGurunanak-23", "ALGurunanak-24", "ALGurunanak-25", "ALGurunanak-26"].includes(currentUnit)) {
          return "1st Floor";
        } else if (["ALGurunanak-27", "ALGurunanak-28", "ALGurunanak-29", "ALGurunanak-30"].includes(currentUnit)) {
          return "2nd Floor";
        }
        return "Ground Floor";
      }
      case "ALManipal":
        return "Ground Floor";
      case "ALSanduGarden": {
        if (["ALSanduGarden-1", "ALSanduGarden-2"].includes(currentUnit)) {
          return "Ground Floor";
        } else if (["ALSanduGarden-3", "ALSanduGarden-4", "ALSanduGarden-5", "ALSanduGarden-6"].includes(currentUnit)) {
          return "1st Floor";
        } else if (["ALSanduGarden-7", "ALSanduGarden-8", "ALSanduGarden-9", "ALSanduGarden-10"].includes(currentUnit)) {
          return "2nd Floor";
        } else if (["ALSanduGarden-11", "ALSanduGarden-12", "ALSanduGarden-13", "ALSanduGarden-14"].includes(currentUnit)) {
          return "3rd Floor";
        }
        return "Ground Floor";
      }
      case "ALPune":
        return "Ground Floor";
      default:
        return 'Ground Floor';
    }
  }

  search() {
    if (this.centreSelected.length === 0 || this.startDate == null || this.endDate == null) {
      this.snackbar.open('Please select a date range and at least one centre', '', {
        duration: 3000,
        panelClass: 'error'
      });
      return;
    }

    this.isLoading = true;
    this.mData = [];

    // Convert dates to Firestore Timestamps for comparison
    const startTimestamp = Timestamp.fromDate(this.startDate);
    const endTimestamp = Timestamp.fromDate(this.endDate);

    // Create queries for each selected centre
    const queries = this.centreSelected.map(centreCode => {
      return this.mFirestore.collection<FullChild>('ALChild', ref =>
        ref.where('centreCode', '==', centreCode)
      ).get().pipe(
        take(1),
        map(snapshot => snapshot.docs.map(doc => doc.data()))
      );
    });

    // Execute all queries in parallel
    forkJoin(queries.length > 0 ? queries : [of([])]).subscribe({
      next: (results) => {
        // Flatten all results
        const allChildren: FullChild[] = results.flat();

        // Process children data
        allChildren.forEach(child => {
          if (!child.admissionData || child.admissionData.length === 0) return;

          child.admissionData.forEach((ad, i) => {
            if (i % 2 !== 0) return; // Only process even indices

            const isSelectedCentre = this.centreSelected.includes(ad.centreCode) ||
              this.centreSelected.includes(ad.transferFrom);

            if (!isSelectedCentre) return;

            const admissionDate = ad.dateOfAdmission?.toDate();
            const dischargeDate = child.admissionData[i + 1]?.dateOfDischarge?.toDate();

            let shouldInclude = false;

            // Case 1: Admitted during date range
            if (admissionDate && this.startDate && this.endDate &&
              admissionDate >= this.startDate && admissionDate <= this.endDate) {
              shouldInclude = true;
            }
            // Case 2: Admitted before but discharged during date range
            else if (admissionDate && this.startDate && this.endDate && dischargeDate &&
              admissionDate <= this.startDate &&
              dischargeDate >= this.startDate && dischargeDate <= this.endDate) {
              shouldInclude = true;
            }
            // Case 3: Admitted before and never discharged
            else if (admissionDate && this.startDate &&
              admissionDate < this.startDate && !child.admissionData[i + 1]) {
              shouldInclude = true;
            }

            if (shouldInclude) {
              let obj: any = {
                "name": `${child.firstName} ${child.lastName}`,
                "centre": child.centreCode,
                "unit": ad.currentUnit,
                "childCode": child.childCode,
                "floor": this.getFloor(ad.centreCode, ad.currentUnit),
                "dateOfAdmission": admissionDate,
                "transferFromUnit": ad.transferFromUnit,
                "transferFrom": ad.transferFrom,
                "transferDate": (ad.transferDate as unknown as Timestamp)?.toDate(),
                "type": (child.admissionData.length > 2) ? 'Follow Up' : 'New'
              };

              if (child.admissionData[i + 1]) {
                obj.dateOfDischarge = dischargeDate;
              }

              this.mData.push(obj);
            }
          });
        });

        // Update table
        this.dataSource = new MatTableDataSource(this.mData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching data:', error);
        this.snackbar.open('Error loading data. Please try again.', '', {
          duration: 3000,
          panelClass: 'error'
        });
        this.isLoading = false;
      }
    });
  }

  onCentreSelect(selectedCentres: Centre[]) {
    if (!selectedCentres || selectedCentres.length === 0) {
      this.centreSelected = [];
      this.mFloorArray = [];
      return;
    }

    this.centreSelected = selectedCentres.map(c => c.centreCode);
    this.mFloorArray = [];

    const floorMap: { [key: string]: string[] } = {
      'ALAhmedabad': ['Ground Floor', '1st Floor', '2nd Floor', '3rd Floor'],
      'ALBangalore': ['Ground Floor', '1st Floor'],
      'ALChandigarh': ['Ground Floor', '1st Floor', '2nd Floor'],
      'ALDiamondGarden': ['Ground Floor'],
      'ALGurunanak': ['Ground Floor', '1st Floor', '2nd Floor'],
      'ALManipal': ['Ground Floor'],
      'ALPune': ['Ground Floor'],
      'ALSanduGarden': ['Ground Floor', '1st Floor', '2nd Floor', '3rd Floor']
    };

    this.centreSelected.forEach(code => {
      if (floorMap[code]) {
        this.mFloorArray.push(...floorMap[code]);
      }
    });

    this.mFloorArray = [...new Set(this.mFloorArray)];
  }

  onFloorSelect($event: MatSelectChange) {
    let filterValue = $event.value;
    if (filterValue == 'All') {
      this.dataSource.filter = '';
    } else {
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  protected readonly PermissionType = PermissionType;
}
